export const STAGE_STREAM_MODES = {
    highResolution: 'highResolution',
    lowResolution: 'lowResolution',
    audioOnly: 'audioOnly',
    liteMode: 'liteMode',
};
